// src/services/endpoints.js
const endpoints = {
  getAllJobs: 'api/Jobs/getmyjobs',
  createJob: 'api/Jobs/createjob',
  uploadImage: '/api/Jobs/upload/',
  updateJob: 'api/Jobs/updatejob',
  updateNewJob: 'api/Jobs/updatenewjob?',
  getJobById: 'api/Jobs/getjobbyid',
  sendQuote: 'api/Jobs/',
  getQuoteByJobId: 'api/Jobs/quote/',
  getQuoteTemplate: 'api/QuoteTemplate',
  createQuoteTemplate: 'api/QuoteTemplate',
  getAllJobResponseByJobId: 'api/Jobs/getresponses/',
  sendResponse: 'api/Jobs/',
  getBusinessResponseById: 'api/Jobs/responses/',
  hireByJobAndBusinessId: 'api/Jobs/',
  getAllJobsForBusiness: 'api/Jobs/getMyJobsForBusiness',
};

export default endpoints;
